import React from 'react';
import WasherManagement from '../../WasherManagement';
import Modal from '../../Modal';

/**
 * 管理 - 洗浄機管理ページ
 */
function Washers({
  selectedCompany,
  washers,
  locationNodes,
  locationTypes,
  handleAddWasher,
  handleEditWasher,
  handleDeleteWasher,
  handleAssignWasher,
  handleUnassignWasher,
  handleViewWasherHistory,
  theme,
  showWasherModal,
  setShowWasherModal,
  editingWasher,
  washerForm,
  setWasherForm,
  handleSaveWasher
}) {
  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <h2>洗浄機管理</h2>
      </div>

      {selectedCompany ? (
        <div>
          <div style={{ marginBottom: '20px', textAlign: 'right' }}>
            <button className="btn btn-primary" onClick={handleAddWasher}>
              + 洗浄機登録
            </button>
          </div>
          
          <WasherManagement
            company={selectedCompany}
            washers={washers}
            locationNodes={locationNodes}
            locationTypes={locationTypes}
            onAdd={handleAddWasher}
            onEdit={handleEditWasher}
            onDelete={handleDeleteWasher}
            onAssign={handleAssignWasher}
            onUnassign={handleUnassignWasher}
            onViewHistory={handleViewWasherHistory}
            theme={theme}
          />
          
          {/* 洗浄機登録・編集モーダル */}
          {showWasherModal && (
            <Modal
              title={editingWasher ? '洗浄機情報編集' : '洗浄機登録'}
              onClose={() => setShowWasherModal(false)}
              width="500px"
            >
                
                <div className="form-group">
                  <label>洗浄機コード *</label>
                  <input
                    type="text"
                    value={washerForm.washer_code}
                    onChange={(e) => setWasherForm({ ...washerForm, washer_code: e.target.value })}
                    placeholder="例: W001"
                  />
                </div>

                <div className="form-group">
                  <label>洗浄機名 *</label>
                  <input
                    type="text"
                    value={washerForm.washer_name}
                    onChange={(e) => setWasherForm({ ...washerForm, washer_name: e.target.value })}
                    placeholder="例: A号洗浄機"
                  />
                </div>

                <div className="form-group">
                  <label>シリアル番号</label>
                  <input
                    type="text"
                    value={washerForm.serial_number}
                    onChange={(e) => setWasherForm({ ...washerForm, serial_number: e.target.value })}
                    placeholder="例: SN123456789"
                  />
                </div>

                <div className="form-group">
                  <label>型式</label>
                  <input
                    type="text"
                    value={washerForm.model_name}
                    onChange={(e) => setWasherForm({ ...washerForm, model_name: e.target.value })}
                    placeholder="例: MODEL-X200"
                  />
                </div>

                <div className="form-group">
                  <label>状態 *</label>
                  <select
                    value={washerForm.status}
                    onChange={(e) => setWasherForm({ ...washerForm, status: e.target.value })}
                  >
                    <option value="active">稼働中</option>
                    <option value="maintenance">メンテナンス中</option>
                    <option value="inactive">停止中</option>
                    <option value="retired">廃棄済み</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>備考</label>
                  <textarea
                    value={washerForm.notes}
                    onChange={(e) => setWasherForm({ ...washerForm, notes: e.target.value })}
                    placeholder="備考を入力してください"
                    rows="3"
                  />
                </div>

                <div className="modal-actions">
                  <button className="btn btn-secondary" onClick={() => setShowWasherModal(false)}>
                    キャンセル
                  </button>
                  <button 
                    className="btn btn-primary" 
                    onClick={handleSaveWasher}
                    disabled={!washerForm.washer_code || !washerForm.washer_name}
                  >
                    {editingWasher ? '更新' : '登録'}
                  </button>
                </div>
            </Modal>
          )}
        </div>
      ) : (
        <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>
          会社管理画面から「洗浄機管理」ボタンをクリックして、洗浄機を管理してください。
        </div>
      )}
    </div>
  );
}

export default Washers;
